// extracted by mini-css-extract-plugin
export default {"confirm":"Confirm_confirm__UT8Ax","title":"Confirm_title__tpjWl","buttonRow":"Confirm_buttonRow__LOdKz"};